module.exports = __webpack_public_path__ + "media/auto_history/men-0feb927e.svg";